import { Grid } from "@mui/material";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { EdcOptionalAddress } from "./EdcOptionalAddress";
import { EdcOptionalCoordinatesForm } from "./EdcOptionalCoordinatesForm";

export const EdcOptionalForm = ({ disabledFields }: MdmFormProps) => {
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={9}>
        <EdcOptionalAddress disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={3}>
        <EdcOptionalCoordinatesForm disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
};
